<template>
  <div class="min-h-screen flex flex-col">
    <Navbar v-if="loadingMenu" :tituloNovedades="tituloNovedades" :menuItems="menuNovedades"/>
    <div class="flex-grow">
      <router-view />
    </div>   
    <Footer/>  
  </div>

</template>

<!-- <script>

import Navbar from './components/Navbar'
import Footer from './components/Footer'

export default ({
  components: {
    Navbar,
    Footer
  },
  setup() {
    
  },
  
  data(){
    return{
      menuNovedades: [],
      tituloNovedaes: '',
      loadingMenu: false
    }
  },

  methods: {
    async getMenuNovedades(){

      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/menu-novedades`;
      const response = await fetch(get,{method: 'GET'})
      let data = await response.json()

      this.menuNovedades = data.menuNovedades
      this.tituloNovedaes = data.tituloNovedaes

      this.loadingMenu = true
     
    } 
  },

  created(){
    this.getMenuNovedades()
  }

})
</script> -->

<script>

import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import { provide, ref, onMounted } from 'vue';

export default {
  components: {
    Navbar,
    Footer,
  },
  setup() {
    const tituloNovedades = ref('');
    const loadingMenu = ref(false);
    const menuNovedades = ref([]);

    const getMenuNovedades = async () => {
      const get = `${process.env.VUE_APP_URL_CULTURAPP}api/menu-novedades`;
      const response = await fetch(get, { method: 'GET' });
      const data = await response.json();

      menuNovedades.value = data.menuNovedades;
      tituloNovedades.value = data.tituloNovedades;
      loadingMenu.value = true;
    };

    onMounted(() => {
      getMenuNovedades();
    });

    // Proporciona la variable tituloNovedaes a los componentes hijos
    provide('tituloNovedades', tituloNovedades);

    // Devuelve las variables que deseas exponer en el template
    return {
      tituloNovedades,
      loadingMenu,
      menuNovedades,
    };
  },
};
</script>


